"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

_immutabilityHelper.default.extend('$each', function (spec, arr) {
  return arr.map(function (item) {
    return (0, _immutabilityHelper.default)(item, spec);
  });
});

var _default = _immutabilityHelper.default;
exports.default = _default;